import { isNull, isUndefined } from 'lodash/fp';
import React, { useMemo } from 'react';

import { useAppSelector } from '../../../../../hooks/react-redux';
import { DATASET_HEIGHT_OFFSET, PAGE_MARGIN_PADDING_BORDER, useSplitView } from '../../../../../hooks/useSplitView';
import { getDocumentAnalysisView } from '../../../../documents/my-documents/store';
import { DatasetType } from '../../../store';
import { FormInstance } from '../../form-instance/FormInstance';
import { getCurrentInstances, getECSDatasetId, getHiddenFields } from '../../store';

interface MLECSInstanceProps {
    isEditing: boolean;
    isUpdating: boolean;
    instanceExecutedDateMatchesParent: boolean;
}

export const MLECSInstance: React.FC<MLECSInstanceProps> = ({ isEditing, isUpdating, instanceExecutedDateMatchesParent }) => {
    const ecsDatasetId = useAppSelector(getECSDatasetId);
    const allInstances = useAppSelector(getCurrentInstances);
    const hiddenFields = useAppSelector(getHiddenFields);
    const widthOffset = PAGE_MARGIN_PADDING_BORDER + 10;
    const heightOffset = DATASET_HEIGHT_OFFSET;
    const documentAnalysisView = useAppSelector(getDocumentAnalysisView);
    const [width] = useSplitView(documentAnalysisView, widthOffset, heightOffset);

    const ecsFormInstance = useMemo(() => allInstances.find(({ instance }) => !isNull(instance.datasetId) && !isNull(ecsDatasetId) && instance.datasetId === ecsDatasetId), [allInstances, ecsDatasetId]);

    if (isNull(ecsDatasetId) || isUndefined(ecsFormInstance)) {
        return null;
    }

    const { instance, parentFieldId } = ecsFormInstance;

    return (
        <div style={{ width: `${width}px`, maxWidth: `${width}px`, height: '100%' }}>
            {instance.datasetType === DatasetType.FORM && <FormInstance datasetInstance={instance} isEditing={isEditing} isUpdating={isUpdating} hiddenFields={hiddenFields} modalInstance={false} parentFieldId={parentFieldId} instanceExecutedDateMatchesParent={instanceExecutedDateMatchesParent} isMLCorrection />}
        </div>
    );
};
